import React, { useMemo } from 'react';
import {
  selectCodiceStatoAvvenimento,
  selectDataOra,
  selectDescrizionePremio,
  selectDescrizioneRiunione,
  selectMeteo,
} from 'features/ippica/selectors';

import { IconLabelWeatherRendered } from 'components/iconLabelWeatherRendered';
import classNames from 'classnames';
import { format } from 'date-fns';
import { retriveStatoScommessaByKey } from 'features/ippica/functions';
import styles from './IppicaHeaderDetailsBox.module.scss';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export const IppicaHeaderDetailsBox = () => {
  const { isMobile } = useWindowSize();

  const descrizioneRiunione = useTypedSelector(selectDescrizioneRiunione);
  const descrizionePremio = useTypedSelector(selectDescrizionePremio);
  const dataOraAvvenimento = useTypedSelector(selectDataOra);
  const codiceStatoAvvenimento = useTypedSelector(selectCodiceStatoAvvenimento);
  const meteo = useTypedSelector(selectMeteo);

  const { statoTipoScommessa, statusClassName } = useMemo(() => {
    const statoTipoScommessa = retriveStatoScommessaByKey(codiceStatoAvvenimento ?? -1);
    const stCodiceStatoAvvenimento = `${statoTipoScommessa ?? ''}`.replace(/ /g, '-').toLowerCase();
    const result: Array<string> = [styles.status];
    if (stCodiceStatoAvvenimento) {
      result.push(styles[stCodiceStatoAvvenimento]);
    }
    return { statoTipoScommessa, statusClassName: result.join(' ') };
  }, [codiceStatoAvvenimento]);

  // const renderDescrizione = (): JSX.Element => {
  //   let objResult: JSX.Element | string | undefined;
  //   if (isMobile) {
  //     // if (isTruthy(descrizionePremio?.length)) {
  //     //   objResult = (
  //     //     <React.Fragment>
  //     //       Premio <span className={styles.premio}>{descrizionePremio}</span>
  //     //     </React.Fragment>
  //     //   );
  //     // } else if (isTruthy(descrizioneRiunione?.length)) {
  //     //   objResult = descrizioneRiunione;
  //     // }
  //   }
  //   return <div className={styles.ippodromo}>{objResult}</div>;
  // };

  const renderBox = (): JSX.Element => {
    let objResult: JSX.Element | string | undefined;
    if (isMobile) {
      objResult = (
        <React.Fragment>
          <li className={styles.dateTime}>
            {dataOraAvvenimento && (
              <>
                <span className={styles.date}>{format(new Date(dataOraAvvenimento), 'd/MM')} </span>
                <span className={styles.timing}>{format(new Date(dataOraAvvenimento), 'kk:mm')}</span>
                {meteo && !meteo.includes('-') && (
                  <>
                    <span className={styles.separator} />
                    <span className={styles.meteo}>
                      <IconLabelWeatherRendered value={meteo} />
                    </span>
                  </>
                )}
              </>
            )}
          </li>
          <li>{<span className={styles.nomeAvvenimento}>{descrizioneRiunione}</span>}</li>
          <li>{<span className={statusClassName}>{statoTipoScommessa}</span>}</li>
          {/* TODO CHECK */}
        </React.Fragment>
      );
    } else {
      objResult = (
        <React.Fragment>
          <li className={styles.date}>{dataOraAvvenimento && format(new Date(dataOraAvvenimento), 'd/MM')}</li>
          <li className={styles.time}>
            {dataOraAvvenimento && format(new Date(dataOraAvvenimento), 'kk:mm')}
            {codiceStatoAvvenimento && <span className={statusClassName}>{statoTipoScommessa}</span>}
          </li>
          {/* TODO CHECK */}
          {meteo && !meteo.includes('-') && (
            <li className={styles.meteo}>
              <IconLabelWeatherRendered value={meteo} />
            </li>
          )}
        </React.Fragment>
      );
    }
    return (
      <ul className={classNames(styles.infoList, { [styles.row]: descrizioneRiunione || descrizionePremio })}>
        {objResult}
      </ul>
    );
  };
  return (
    <React.Fragment>
      {renderBox()}
      {/* <ul className={classNames(styles.infoList, { [styles.row]: descrizioneRiunione || descrizionePremio })}>
        <li className={styles.date}>{dataOraAvvenimento && format(new Date(dataOraAvvenimento), 'd/MM')}</li>
        <li className={styles.time}>
          {dataOraAvvenimento && format(new Date(dataOraAvvenimento), 'kk:mm')}
          {codiceStatoAvvenimento && <span className={statusClassName}>{statoTipoScommessa}</span>}
        </li>
        {meteo && !meteo.includes('-') && (
          <li className={styles.meteo}>
            <IconLabelWeatherRendered value={meteo} />
          </li>
        )}
      </ul> */}
      {/* {renderDescrizione()} */}
    </React.Fragment>
  );
};
